import React from 'react';
import NotificationCard from '@/components/notifications/NotificationCard';
import { PoolNotification } from '@/types/notification';

type ActivitySectionProps = {
  notifications: PoolNotification[];
  loading: boolean;
};

export const ActivitySection: React.FC<ActivitySectionProps> = ({ notifications, loading }) => {
  return (
    <div className="w-full mt-8 flex flex-col justify-start items-start gap-4">
      <div className="w-full flex justify-start items-center gap-3">
        <div
          className="text-[#113D7B] text-base font-extrabold break-words"
          style={{
            fontFamily: 'var(--ep-font-avenir)',
          }}
        >
          Recent activity
        </div>
      </div>

      {loading ? (
        <div
          className="p-5 text-center text-[#B2B2B2]"
          style={{
            fontFamily: 'var(--ep-font-avenir)',
          }}
        >
          Loading activity...
        </div>
      ) : notifications.length === 0 ? (
        <div
          className="p-5 text-center text-[#B2B2B2]"
          style={{
            fontFamily: 'var(--ep-font-avenir)',
          }}
        >
          No activity yet
        </div>
      ) : (
        <div className="w-full flex flex-col justify-start items-start gap-2">
          {notifications.map((notification) => (
            <NotificationCard key={notification.id} notification={notification} variant="full" />
          ))}
        </div>
      )}
    </div>
  );
};
